export var RecipeTypeText;
(function (RecipeTypeText) {
    RecipeTypeText["NoRecipesTypesAvailable"] = "No recipe types to display";
    RecipeTypeText["WarningModalDefaultText"] = "Changing this will remove all your recipes from the cart";
})(RecipeTypeText || (RecipeTypeText = {}));
